module.exports = __webpack_public_path__ + "ptc_nakagawa_K1.76d84185.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_K1.jpg
// module id = jtzF
// module chunks = 0